import React from "react";

interface ProfileAvatarProps {
    initials: string;
    imageUrl?: string;
    size?: number; // Default size is 64px
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ initials, imageUrl, size = 64 }) => {
    const fullUrl = imageUrl
        ? imageUrl.startsWith('http') ? imageUrl : import.meta.env.VITE_BUCKET_URL + imageUrl
        : null;

    return (
        <div
            className="flex items-center justify-center rounded-full overflow-hidden bg-gray-200 text-gray-600 font-bold"
            style={{ width: size, height: size, fontSize: size * 0.4 }}
        >
            {imageUrl ? (
                <img
                    src={fullUrl!}
                    alt="Avatar"
                    className="w-full h-full object-cover"
                    onError={(e) => {
                        e.currentTarget.style.display = 'none';
                        const parent = e.currentTarget.parentElement;
                        if (parent) {
                            const span = parent.querySelector('span');
                            if (span) {
                                span.style.display = 'block';
                            }
                        }
                    }}
                />
            ) : null}
            <span style={{ display: imageUrl ? 'none' : 'block' }}>{initials}</span>
        </div>
    );
};

export default ProfileAvatar;